<template>
  <v-tabs v-model="tab" @change="handleOnChangeTab" fluid>
    <v-tab><h2>瀏覽</h2></v-tab>
    <!-- <v-tab><h2>新增</h2></v-tab> -->
    <!--  -->
    <v-tab-item v-if="isShowTabContent">
      <AddOneListBrowe />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import AddOneListBrowe from './subComponents1/addOneListBrowe.sc.vue'
export default {
  data: () => ({
    tab: sessionStorage.getItem('tab2') * 1 || 0,
    isShowTabContent: true
  }),
  components: {
    AddOneListBrowe
  },
  computed: {},
  methods: {
    async handleOnChangeTab() {
      sessionStorage.setItem('tab2', this.tab)
      // #region Important: run component's created per touch tab
      this.isShowTabContent = false
      this.$nextTick(() => {
        this.isShowTabContent = true
      })
      // #endregion
    }
  },
  created() {
    this.$emit('setTopLabel', 3)
  },
  mounted() {}
}
</script>

<style scoped></style>
